<template>
  <div v-show="showHeaderMenu">
    <div class="saved-card-slider-wrapper">
      <div :class="getSavedCardSliderClass()" >
        <!-- If we need navigation buttons -->
        <div class="swiper-button-prev">
          <img src="/img/prev-button.png" width="29" alt="wRatings" />
        </div>

        <div ref="savedCardSwiper" class="swiper">
          <div class="swiper-wrapper">
            <div class="swiper-slide" v-for="(clientChart, idxClientChart) in this.displayedSavedCards" :key="idxClientChart">

                <chart-card :chart-card-object="clientChart" :clientChartIds="$parent.clientChartIds" :setType="setType" :viewType="viewType" 
                            @delete="resetClientCharts" @update="updateCardListForReport"/>
            </div>
          </div>
        </div>

        <div class="swiper-button-next">
          <img src="/img/next-button.png" width="29" alt="wRatings" />
        </div>
        <!-- If we need scrollbar -->
        <div class="d-none swiper-scrollbar"></div>
      </div>
      <!-- If we need pagination -->
      <!-- <div class="swiper-pagination"></div> -->

    </div>
  </div>
</template>
<script>
import Swiper, { Navigation, Pagination, Scrollbar, A11y } from 'swiper';

// Import Swiper Vue.js components
Swiper.use([ Navigation, Pagination, Scrollbar, A11y ]);

// Import Swiper styles
import 'swiper/swiper-bundle.min.css';


import router from "../../router";
import Vue from "vue";
import MenuMixins from "../../mixins/MenuMixins.vue";
import SavedCardMixins from "../../mixins/SavedCardMixins.vue";
import ChartCard from "../../components/chart/ChartCard.vue";
import {useRouter} from "vue-router";
Vue.use(useRouter);

export default {
  name: "SavedCardMenu",
  components: {ChartCard},
  mixins: [MenuMixins,SavedCardMixins],
  router,
  props: {},
  data() {
    return {
      swiper: null
    };
  },
  methods: {
    getSavedCardSliderClass() {
      let baseClass = "saved-card-slider-slider";
      if (this.displayedSavedCards.length < 7) {
        baseClass += " small-card-slider";
      }
      return baseClass;
    },
    buildSavedCardTable() {
      this.cardsToShow = this.originalSavedCards.length;
      this.getDisplayedSavedCards();
      // filter dashboard cards
      this.displayedSavedCards = this.displayedSavedCards.filter(card => {
        return card.dashboardCardId == 0;
      });
    },
    updateCardListForReport(){}
  },
  created() {},
  mounted() {
    this.showCards = true;
    if (this.showCards == true){
      this.buildSavedCardTable();
    }    
    this.swiper = new Swiper(this.$refs.savedCardSwiper, {
        // configure Swiper to use modules
        modules: [Navigation, Pagination, Scrollbar, A11y],
        // Optional parameters
        loop: false,
        // If we need pagination
        pagination: {
          el: '.swiper-pagination',
        },

        // Navigation arrows
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        // Responsive breakpoints
        breakpoints: {
          // when window width is >= 1300px
          1350: {
            slidesPerView: 7,
          },
          // when window width is >= 1024px
          1024: {
            slidesPerView: 5,
          },
          // when window width is >= 768px
          768: {
            slidesPerView: 4,
          },
          // when window width is < 768px
          0: {
            slidesPerView: 2,
          },
        },    
      });

      
  },
  watch: {
    displayedSavedCards() {
      this.$nextTick(() => {
        if (this.swiper) {
          this.swiper.update();
        }
      });
    }    
  },
  computed: {},
  unmounted() {
    if (this.swiper) {
      this.swiper.destroy(true, true);
      this.swiper = null;
    }
  }
};
</script>
